import { Env, readFromEnv } from "@cinch-nx/environments";
export var ReservationsDecouplingPhase;
(function(ReservationsDecouplingPhase) {
    ReservationsDecouplingPhase["PHASE_ONE"] = "PHASE_ONE";
    ReservationsDecouplingPhase["PHASE_TWO"] = "PHASE_TWO";
})(ReservationsDecouplingPhase || (ReservationsDecouplingPhase = {}));
export var getReservationsDecouplingFlags = function() {
    return {
        phaseOne: readFromEnv(Env.CheckoutReservationsDecoupling),
        phaseTwo: readFromEnv(Env.CheckoutReservationsDecouplingPhaseTwo)
    };
};
export var getReservationsDecouplingPhase = function() {
    var ref = getReservationsDecouplingFlags(), phaseOne = ref.phaseOne, phaseTwo = ref.phaseTwo;
    if (phaseTwo === "true") {
        return ReservationsDecouplingPhase.PHASE_TWO;
    }
    if (phaseOne === "true") {
        return ReservationsDecouplingPhase.PHASE_ONE;
    }
    return;
};
export var isReservationsDecouplingEnabled = function(reservationsDecouplingPhase) {
    return !!reservationsDecouplingPhase;
};
